import { get } from 'lodash-es';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import { getParamsFromVehicle } from 'site-modules/shared/utils/core-page/params';
import { buildMMYSubmodelTrimPhotosPathWithParams, PhotosModel } from 'client/data/models/photos';

export const learnMoreDataProvider = WrappedComponent =>
  connectToModel(WrappedComponent, {
    photoUrl: bindToPath(
      ({ vehicle }) =>
        vehicle &&
        buildMMYSubmodelTrimPhotosPathWithParams({
          ...getParamsFromVehicle(vehicle),
          submodel: vehicle.submodels.name,
          width: '300',
        }),
      PhotosModel,
      photos => get(photos, '[0].href', ''),
      false
    ),
  });
